import { notifyJoyfulExtension } from '@/features/auth/utils/notifyExtension'
import { useActiveAccount } from '@joyful/ui/app'
import { useEffect } from 'react'

// Pushes the webapp's active account to the Joyful Chrome extension so the
// sidecar stays scoped to whatever the user picked here. Depends on the
// primitive fields rather than the account object reference so a re-render
// that produces a fresh object with identical values doesn't fire a redundant
// cross-origin message.
export function useNotifyExtensionActiveAccount() {
  const activeAccount = useActiveAccount()

  useEffect(() => {
    notifyJoyfulExtension({
      account: activeAccount,
      type: 'active-account-changed',
    })
  }, [activeAccount])
}
